<template>
  <card>
    <h3 slot="header" class="mb-0">New Project Task Template Detail for ({{ task_template_name }}) </h3>
    <div class="text-right">
    </div>
    <form class="needs-validation"
          @submit.prevent="submit">

      <div class="form-row">
        <b-col md="8">
          <base-input label="Task Title"
                      name="Task Title"
                      placeholder="Task Title"
                      v-model="model.project_task_title" required>
          </base-input>
        </b-col>

        <b-col md="4">
          <base-input label="Task Status"
                      name="Task Status"
                      v-model="model.status_id">
            <select class="form-control" v-model="model.status_id">
              <option Selected disabled value="x">-- Please Select Task Status --</option>
              <option v-for="item in task_status" :key="item.status_id" v-bind:value="item.status_id">{{ item.status_code }}</option>
            </select>
          </base-input>
        </b-col>

        <b-col md="12">
          <base-input label="Description"
                      name="Title"
                      placeholder="Task Description"
                      v-model="model.project_task_description" required>
          </base-input>
        </b-col>
      </div>
      <div class="form-row">
        <b-col md="4">
          <b-form-checkbox
            id="Active-Status"
            v-model="model.active_status"
            name="Active-Status"
            value="1"
            unchecked-value="0">
            <b>Active Status</b>
          </b-form-checkbox>
        </b-col>
      </div>
      <br>
      <base-button type="primary" @click="createData()">Create / Save</base-button>
      <base-button type="primary" @click="$router.back()">Cancel</base-button>
    </form>
  </card>
</template>
<script>
  import BaseSlider from '@/components/BaseSlider'
  import {LoginURL, clientId, clientSecret, apiDomain, getHeader} from '@/assets/js/config.js'
  import axios from 'axios'
  import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

  export default {
    mixins: [ErrorFunctionMixin],
    components: {
      BaseSlider
    },
    created()
    {
      this.model.project_task_template_id = this.$route.params.id
      axios.get(apiDomain + 'template/project_task_template/'+this.model.project_task_template_id, { headers: getHeader() })
      .then ( response => {
        if (response.status === 200)
        {
          this.task_template_name = response.data.data[0].task_template_name
        }
      })
      .catch ( error => {
          console.log(error.response.status)
          this.errorFunction(error, "Project Task Template Information")
      });

      this.getTaskStatus()

    },
    data() {
      return {
        model: {
          project_task_template_detail_id: null,
          project_task_template_id: null,
          project_task_title: null,
          project_task_description: null,
          document_type_id: 'x',
          status_id: 'x',
          active_status: 1,
        },
        task_status: [],
        task_template_name: null,
      }
    },
    methods: {
      getTaskStatus()
      {
        axios.get(apiDomain + 'lookup/task_status', { headers: getHeader() })
        .then ( response => {
          if (response.status === 200)
          {
            this.task_status = response.data.data
          }
        })
        .catch ( error => {
          console.log(error.response.status)
          this.errorFunction(error, "Task Status Code", "Task Status")
        } );
      },
      createData(){
        if ( !this.model.project_task_title || this.model.status_id == 'x' )
        {
          this.$notify({
            message:
              '<b>Invalid Input : All Column are Mandatory in Project Task Template Details </b> - These field are required.',
            timeout: 10000,
            icon: 'ni ni-bulb-61',
            type: 'danger',
          });
        }
        else
        {
          axios.post(apiDomain + 'template/project_task_template_details', this.model, { headers: getHeader() })
          .then ( response => {
            if (response.status === 200)
            {
                this.$notify({
                message:
                  '<b>New Project Task Template Details : ' + this.model.project_task_title + '</b> - Successfully Created.',
                timeout: 10000,
                icon: 'ni ni-bell-55',
                type: 'default',
                });
                this.$router.back()
            }
          })
          .catch ( error => {
            console.log(error.response.data.errors)
            this.errorFunction(error, "Create New Project Task Template Details", this.model.project_task_title)
          });
        }
      },
    }
  }
</script>
<style>
</style>
